import { render, staticRenderFns } from "./Semafor.vue?vue&type=template&id=1aa1a4b7&scoped=true"
import script from "./Semafor.vue?vue&type=script&lang=js"
export * from "./Semafor.vue?vue&type=script&lang=js"
import style0 from "./Semafor.vue?vue&type=style&index=0&id=1aa1a4b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa1a4b7",
  null
  
)

export default component.exports